// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__8ILkr","label":"LanguagePicker_label__GCv2d","icon":"LanguagePicker_icon__7JyVL"};